import Image from "components/Elements/Image/Image";

import { memo } from "react";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./successSubmit.module.scss";

const SuccessSubmit = () => {
  const { getTextByKey } = useContent();
  return (
    <div className={styles.wrapper}>
      <div className={styles.successImage}>
        <Image name="cloud_success" className={styles.cloudSuccess} />
        <Image
          name="cloud_shadow_success"
          className={styles.cloudShadowSuccess}
        />
        <Image
          name="letter_icon_success"
          className={styles.letterIconSuccess}
        />
        <Image name="ok_icon_success" className={styles.okIconSuccess} />
        <Image
          name="flight_icon_success"
          className={styles.flightIconSuccessRight}
        />
        <Image
          name="flight_icon_success"
          className={styles.flightIconSuccessLeft}
        />
        <Image name="phone_icon_success" className={styles.phoneIconSuccess} />
        <Image
          name="comment_icon_success"
          className={styles.commentIconSuccess}
        />
      </div>
      <h3>{getTextByKey("thank-you")}</h3>
      <p className={styles.description}>{getTextByKey("contact-us-success-description")}</p>
      <p className={styles.privacyHint}>{getTextByKey("contact-us-privacy-hint")}</p>
    </div>
  );
};

export default memo(SuccessSubmit);
